import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ChevronLeft as ChevronLeftIcon } from "@mui/icons-material";
import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";
import { Box, IconButton, Select, Tab, Tabs as MuiTabs, } from "@mui/material";
import { CollapseChip } from "./CollapseChip.js";
import { useScreenWidth } from "./hooks/useScreenWidth.js";
import { withStyles } from "./styles.js";
const defaultFilterSelectOption = () => true;
export const Tabs = ({ value, onChange, options, condensed = false, useSelect = false, useSelectOnMobile = false, notSelectedTitle = "Not selected", onDeselect, tabProps, filterSelectOption = defaultFilterSelectOption, }) => {
    const { isMaxPhone } = useScreenWidth();
    return useSelect || (isMaxPhone && useSelectOnMobile) ? (_jsxs(Select, { fullWidth: false, native: true, variant: "outlined", size: "extra-small", value: value || "", onChange: event => {
            const option = options.find(o => o.value === event.target.value);
            if (option !== undefined) {
                // FIXME: problem when multiple options with same label, but that should never happen anyways as it's very confusing for the user
                onChange(option.value);
            }
            else if (option === undefined && onDeselect) {
                onDeselect();
            }
        }, children: [onDeselect ? (_jsx("option", { value: "", children: notSelectedTitle }, "not-selected")) : null, options.filter(filterSelectOption).map((option, index) => (
            // FIXME: problem when multiple options with same label, but that should never happen anyways as it's very confusing for the user
            _jsxs("option", { value: option.value, children: [option.label, option.count !== undefined ? ` (${option.count})` : ""] }, index)))] })) : (_jsx(MuiTabs, { value: value ?? false, onChange: (_e, newValue) => onChange(newValue), indicatorColor: "primary", textColor: "primary", variant: "scrollable", sx: theme => ({
            minHeight: "unset",
            [".MuiTab-root"]: {
                minWidth: "unset",
                minHeight: "unset",
                transition: "background-color 0.1s ease-out",
                padding: condensed ? "6px 6px" : "6px 12px",
                borderRadius: `${theme.shape.borderRadius}px`,
                ["&:hover:not(.Mui-selected)"]: {
                    backgroundColor: theme.palette.action.hover,
                },
                ["&:active:not(.Mui-selected)"]: {
                    backgroundColor: theme.palette.action.selected,
                },
                ["&.Mui-selected"]: {
                    color: theme.palette.primary.main,
                    ...(!onDeselect ? { cursor: "default" } : undefined),
                },
                ["&.Mui-disabled"]: {
                    cursor: "default",
                },
                [".MuiSvgIcon-root"]: {
                    mr: 0.5,
                    fontSize: "1.25rem",
                },
            },
        }), slots: {
            scrollButtons: ScrollButton,
        }, children: options.map((option, index) => (_jsx(Tab, { disabled: (!onDeselect && value === option.value) || option.disabled, value: option.value, label: _jsxs(_Fragment, { children: [option.label, option.count !== undefined && (_jsx(Box, { display: "flex", alignItems: "center", ml: 0.5, component: "span", height: "1em", children: _jsx(CollapseChip, { label: option.count }) }))] }), icon: option.icon, iconPosition: "start", onClick: onDeselect && value === option.value ? onDeselect : undefined, ...tabProps?.(option, index) }, index))) }));
};
function ScrollButton(props) {
    if (props.direction === "left") {
        return (_jsx(IconScrollButton, { color: "primary", disabled: !props.visible, size: "small", ...props, children: _jsx(ChevronLeftIcon, {}) }));
    }
    else if (props.direction === "right") {
        return (_jsx(IconScrollButton, { color: "primary", disabled: !props.visible, size: "small", ...props, children: _jsx(ChevronRightIcon, {}) }));
    }
    else {
        return null;
    }
}
const IconScrollButton = withStyles(IconButton, {
    root: {
        width: "1.5rem",
        height: "1.5rem",
        flexShrink: 0,
        flexGrow: 0,
        alignSelf: "center",
    },
});
//# sourceMappingURL=Tabs.js.map